import { render, staticRenderFns } from "./CreatorVideoJsPlayer.vue?vue&type=template&id=b63764c2&scoped=true&"
import script from "./CreatorVideoJsPlayer.vue?vue&type=script&lang=js&"
export * from "./CreatorVideoJsPlayer.vue?vue&type=script&lang=js&"
import style0 from "./CreatorVideoJsPlayer.vue?vue&type=style&index=0&id=b63764c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b63764c2",
  null
  
)

export default component.exports